import React from 'react';
import { HashLink } from 'react-router-hash-link';
import { useLanguage } from '../../context/LanguageContext'; // Import Language Context

const NavLastLinks = () => {
  const { language, changeLanguage } = useLanguage(); // Access Language Context

  return (
    <div className="flex flex-col lg:flex-row items-center justify-center lg:space-y-0 lg:space-x-6">
      {/* Contact Us */}
      <HashLink
        className="btn-custom bg-black text-white font-bold rounded-md hover:bg-gray-800 transition"
        smooth
        to="/contact"
        aria-label={
          language === 'Shqip'
            ? 'Na kontaktoni - Shkoni tek faqja ku mund të na kontaktoni'
            : 'Contact Us - Navigate to the Contact Page'
        }
        style={{
          height: '40px',
          padding: '0 25px', // Ensure consistent padding
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxSizing: 'border-box', // Ensure consistent sizing
        }}
      >
        {language === 'Shqip' ? 'Na Kontaktoni' : 'Contact Us'}
      </HashLink>

      {/* Language Selector */}
      <div className="flex items-center space-x-4">
        {/* Albanian Language Button */}
        <button
          onClick={() => changeLanguage('Shqip')}
          className={`btn-custom font-bold rounded-md transition ${
            language === 'Shqip'
              ? 'bg-black text-white'
              : 'bg-gray-200 text-black'
          } hover:bg-gray-300`}
          aria-label="Select Albanian Language"
          style={{
            height: '40px', // Set consistent height for buttons
            padding: '0 16px', // Ensure consistent padding
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxSizing: 'border-box', // Ensure consistent sizing
          }}
        >
          <span>Shqip</span>
        </button>

        {/* English Language Button */}
        <button
          onClick={() => changeLanguage('English')}
          className={`btn-custom font-bold rounded-md transition ${
            language === 'English'
              ? 'bg-black text-white'
              : 'bg-gray-200 text-black'
          } hover:bg-gray-300`}
          aria-label="Select English Language"
          style={{
            height: '40px', // Set consistent height for buttons
            padding: '0 16px', // Ensure consistent padding
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxSizing: 'border-box', // Ensure consistent sizing
          }}
        >
          <span>English</span>
        </button>
      </div>
    </div>
  );
};

export default NavLastLinks;